import { LoginMethod } from 'kuaidong-model'
import VueRouter, { RouteConfig } from 'vue-router'

const Login = () => import('../views/custom/guangdong/Login.vue')
const Dashboard = () => import('../views/custom/guangdong/Dashboard.vue')

export const loginRoute: RouteConfig = {
  path: 'guangdong/login',
  name: 'custom_guangdong_login',
  component: Login,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    ignoreLogin: true,
  },
}

export const dashboardRoute: RouteConfig = {
  path: 'guangdong/dashboard',
  name: 'custom_guangdong_dashboard',
  component: Dashboard,
  props: (route) => ({ ...route.query, ...route.params }),
}

export default [loginRoute, dashboardRoute]

export function navigateToCustomGuangdongLogin(router: VueRouter, loginMethod?: LoginMethod) {
  router.push({ name: loginRoute.name, query: { loginMethod } })
}

export function redirectToCustomGuangdongLogin(router: VueRouter, loginMethod?: LoginMethod) {
  router.replace({ name: loginRoute.name, query: { loginMethod } })
}

export function navigateToCustomGuangdongDashboard(router: VueRouter) {
  router.push({ path: dashboardRoute.path })
}
